import React, { Component } from 'react';

class Home extends Component {
	componentDidMount(){
        	document.body.className = "home";
	}
	
	render() {
		return (
    			<div className="witamy">
				<p>Witamy na stronie przychodni weterynaryjnej Vetica.</p>
				<p>Zapraszamy!</p>
			</div>
		)
	}
}
export default Home;